<template>
  <div id="ResNetApp">
    <top-menu />
    <transition name="fade">
      <router-view></router-view >
    </transition>
  </div>
</template>

<script>
import Nav from "@/components/nav";
export default {
  name: "ResNetApp",
  data: () => ({
  }),
  components: {
    "top-menu": Nav
  },
  created() {},
  methods: {}
};
</script>


<style>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.2s;
}

.fade-enter-active {
  transition-delay: 0.2s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
